import { factory } from "../../../../utils/apiThunkFactory";

export const updateBooking = factory.put("myEventModal/handleUpdateBooking", "/api/bookings/update/:bookingId");
export const deleteBooking = factory.delete("myEventModal/deleteBooking", "/api/bookings/delete/:bookingId");
export const createBooking = factory.post("myEventModal/createBooking", "/api/bookings/add");
export const createConference = factory.post("myEventModal/createConference", "/api/bookings/addConference");

export const fetchUsersNotGuest = factory.get("myEventModal/fetchUsersNotGuest", "/api/users/usersNotGuest");
export const fetchRoomsByMapId = factory.get("addEvent/fetchRoomsByMapId","/api/rooms/room-data/:mapId");
export const fetchNonGuestUsersByMap = factory.get("addEvent/fetchNonGuestUserIdsByMap","/api/users/usersNotGuestIds/:mapId");
export const getBookingMapId = factory.get("myEventModal/getBookingMapId", "/api/bookings/getMapId/:bookingId");